import { render, staticRenderFns } from "./HoroscopeResultView.vue?vue&type=template&id=3b910294&scoped=true&"
import script from "./HoroscopeResultView.vue?vue&type=script&lang=ts&"
export * from "./HoroscopeResultView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b910294",
  null
  
)

export default component.exports